import { useEffect, useRef } from "react";
import { Button } from "@/components/ui/button";
import { Eraser } from "@phosphor-icons/react";

export function SignaturePad({ onChange, height = 160, testId = "signature-pad" }) {
  const ref = useRef(null);
  const drawing = useRef(false);

  useEffect(() => {
    const ctx = ref.current.getContext("2d");
    ctx.lineWidth = 2.5;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#0B1120";
  }, []);

  const pos = (e) => {
    const c = ref.current;
    const r = c.getBoundingClientRect();
    return { x: (e.clientX - r.left) * (c.width / r.width), y: (e.clientY - r.top) * (c.height / r.height) };
  };
  const start = (e) => {
    e.preventDefault();
    drawing.current = true;
    const ctx = ref.current.getContext("2d");
    const p = pos(e);
    ctx.beginPath();
    ctx.moveTo(p.x, p.y);
  };
  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const ctx = ref.current.getContext("2d");
    const p = pos(e);
    ctx.lineTo(p.x, p.y);
    ctx.stroke();
    onChange && onChange(ref.current.toDataURL("image/png"));
  };
  const end = () => { drawing.current = false; };
  const clear = () => {
    const cv = ref.current;
    cv.getContext("2d").clearRect(0, 0, cv.width, cv.height);
    onChange && onChange(null);
  };

  return (
    <div>
      <div className="rounded-lg border-2 border-dashed border-[#0055FF]/40 bg-white">
        <canvas
          ref={ref}
          width={440}
          height={height}
          className="w-full touch-none rounded-lg"
          style={{ height }}
          onPointerDown={start}
          onPointerMove={move}
          onPointerUp={end}
          onPointerLeave={end}
          data-testid={`${testId}-canvas`}
        />
      </div>
      <Button variant="ghost" size="sm" className="mt-1 rounded-sm text-muted-foreground" onClick={clear} data-testid={`${testId}-clear`}>
        <Eraser size={16} weight="bold" /> Καθαρισμός
      </Button>
    </div>
  );
}
